import { productCarouselProductFullStyles as styles } from "@solveindustrial/Overrides/Components/ProductCarouselProductFull";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.container = {
    ...styles.container,
    gap: 0,
    offsetCss: css`
        flex-direction: column;
        flex-wrap: nowrap !important;
        gap: 10px;
        height: 100%;

        & > div {
            flex: 1 1 auto;
        }
    `,
};

styles.imageGridItem = {
    ...styles.imageGridItem,
    css: css`
        ${styles.imageGridItem?.css}
        min-height: 150px;
        height: 150px;

        ${mediaQueriesBP.minMD} {
            min-height: 200px;
            height: 200px;
        }
    `,
};

styles.productDescriptionStyles = {
    ...styles.productDescriptionStyles,
    productDetailLink: {
        ...styles.productDescriptionStyles?.productDetailLink,
        css: css`
            ${styles.productDescriptionStyles?.productDetailLink?.css}
            margin: 0;
        `,
    },
};

styles.productImageStyles = {
    ...styles.productImageStyles,
    linkWrappingImage: {
        ...styles.productImageStyles?.linkWrappingImage,
        css: css`
            display: block;
            height: 100%;
        `,
    },
    img: {
        ...styles.productImageStyles?.img,
        css: css`
            height: 100%;
            object-fit: contain;
        `,
    },
};

styles.logInForPriceItem = {
    ...styles.logInForPriceItem,
    width: 12,
    css: css`
        ${styles.logInForPriceItem?.css}
        flex: 1 1 auto;
        margin: auto 0 0 !important;
    `,
};

styles.productStandardActionsItem = {
    ...styles.productStandardActionsItem,
    width: 12,
    css: css`
        ${styles.productStandardActionsItem?.css}
        flex: 1 1 auto;
        margin: auto 0 0 !important;
    `,
};

styles.productStandardActionsContainer = {
    ...styles.productStandardActionsContainer,
    gap: 0,
    css: css`
        ${styles.productStandardActionsContainer?.css}
        padding: 0;
    `,
    offsetCss: css`
        ${styles.productStandardActionsContainer?.offsetCss}
        flex-direction: column;
        flex-wrap: nowrap !important;
        gap: 10px;
        height: 100%;
    `,
};

styles.productAddToListLinkStyles = {
    ...styles.productAddToListLinkStyles,
    link: {
        ...styles.productAddToListLinkStyles?.link,
        css: css`
            ${styles.productAddToListLinkStyles?.link?.css}
            margin: 0;
        `,
    },
};
